/**
 * Feedback Button Component
 * A floating button in the bottom-right corner that opens the feedback modal.
 */
import { FeedbackModal } from './FeedbackModal.js'

export function FeedbackButton() {
  const button = document.createElement('button')
  button.id = 'feedback-button'
  button.className = `
    fixed bottom-20 right-6 z-50
    w-14 h-14 rounded-full
    bg-gradient-to-r from-primary-500 to-primary-600
    text-white shadow-lg
    hover:from-primary-600 hover:to-primary-700
    hover:shadow-xl hover:scale-105
    transition-all duration-200 ease-in-out
    flex items-center justify-center
    focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
  `.replace(/\s+/g, ' ').trim()

  button.innerHTML = `
    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
        d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
    </svg>
  `

  button.title = 'Send Feedback'

  button.addEventListener('click', () => {
    // Check if modal already exists
    let existingModal = document.getElementById('feedback-modal-overlay')
    if (existingModal) {
      existingModal.remove()
    }

    const modal = FeedbackModal()
    document.body.appendChild(modal)
  })

  return button
}
